import React, { useEffect, useMemo, useState } from 'react'
import FloatCard from '../components/Card/FloatCard'
import SearchBox from '../components/Input/SearchBox'
import PrimaryButton from '../components/Button/PrimaryButton'
import Pagination from '../components/Navigation/Pagination'
import { AxiosError } from 'axios'
import EditButton from '../components/EditButton'
import DeleteButton from '../components/DeleteButton'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import get from 'lodash/get'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { formatNumber } from '../utils/formatter'

const StrapiTable = ({
  title,
  headers,
  fetchFunction,
  createLink,
  onEdit,
  onDelete,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState(null)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [sortColumn] = useState(null)
  const [sortOrder] = useState(null)

  const totalPage = useMemo(() => {
    return !data ? 0 : data.meta.pagination.pageCount
  }, [data])

  const totalData = useMemo(() => {
    return !data ? 0 : data.meta.pagination.total
  }, [data])

  const body = useMemo(() => {
    return !data ? [] : data.data
  }, [data])

  useEffect(() => {
    setCurrentPage(1)
  }, [search])

  useEffect(() => {
    const fetch = async () => {
      try {
        setIsLoading(true)
        const data = await fetchFunction({
          currentPage,
          search,
        })
        setData(data)
      } catch (error) {
        let message = "There's something error. Please try again later."
        if (error instanceof AxiosError) {
          message =
            error.response.data?.error?.message ??
            "There's something error. Please try again later."
        }
        toast.error(message, {
          toastId: message,
        })
      } finally {
        setIsLoading(false)
      }
    }
    const getData = setTimeout(() => {
      fetch()
    }, 500)
    return () => clearTimeout(getData)
  }, [search, currentPage])

  return (
    <>
      <FloatCard>
        <div className="pb-2">
          <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-4 border-b border-line">
            <div>
              <div className="font-bold text-base text-ink">{title}</div>
              <div className="text-[13px] text-muted">
                {isLoading
                  ? 'Memuat data...'
                  : `${formatNumber(totalData)} ${title} ditemukan`}
              </div>
            </div>
            {createLink && (
              <Link to={createLink}>
                <PrimaryButton>
                  <FontAwesomeIcon icon={faPlus} />
                  Buat {title}
                </PrimaryButton>
              </Link>
            )}
          </div>
          <div className="px-4 py-3">
            <div className="lg:max-w-[360px]">
              <SearchBox
                placeholder="Pencarian..."
                value={search}
                onChange={setSearch}
              />
            </div>
          </div>
          <div>
            <div className="overflow-x-auto">
              <table className="table w-full">
                <thead>
                  <tr>
                    {headers.map((header) => (
                      <th
                        key={header.label}
                        onClick={
                          header.sortable
                            ? () => onChangeSort(header.value)
                            : null
                        }
                      >
                        {header.sortable ? (
                          <span style={{ cursor: 'pointer' }}>
                            {header.label}
                            {sortColumn === header.value &&
                              (sortOrder === 'asc' ? (
                                <span> &#x2191;</span>
                              ) : (
                                <span> &#x2193;</span>
                              ))}
                          </span>
                        ) : (
                          header.label
                        )}
                      </th>
                    ))}
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading && (
                    <tr>
                      <td
                        colSpan={headers.length + 1}
                        align="center"
                        className="!py-10 text-muted"
                      >
                        Memuat data...
                      </td>
                    </tr>
                  )}
                  {!isLoading && body.length === 0 && (
                    <tr>
                      <td
                        colSpan={headers.length + 1}
                        align="center"
                        className="!py-10 text-muted"
                      >
                        Belum ada data.
                      </td>
                    </tr>
                  )}
                  {!isLoading &&
                    body.map((row, index) => (
                      <tr
                        key={index}
                        className="hover cursor-pointer"
                        onClick={() => {
                          // setDetail(row)
                        }}
                      >
                        {headers.map((header, i) => (
                          <td key={i}>
                            {header.format
                              ? header.format(get(row, header.value))
                              : get(row, header.value)}
                          </td>
                        ))}
                        <td>
                          <div className="flex gap-1">
                            <EditButton onClick={() => onEdit(row.id)} />
                            <DeleteButton
                              onClick={() => {
                                const confirmed = confirm('Apa anda yakin?')
                                if (confirmed) {
                                  onDelete(row.id)
                                }
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-fit mx-auto sm:ml-auto sm:mr-0 px-4 pt-4 pb-2 border-t border-line">
            <Pagination
              totalPage={totalPage}
              currentPage={currentPage}
              onChange={setCurrentPage}
            />
          </div>
        </div>
      </FloatCard>
    </>
  )
}

export default StrapiTable
